<template>
  <div class="third">
    <component
      :is="labelName"
      :ref="labelName"
      :ID="slideshow"
      @backHome="goBackHome"
      @add="toAddRole"
      @check="tocheckRole"
      @redact="toredactRole"
    ></component>
  </div>
</template>

<script>
import cardhome from "./components/cards-index.vue";
import addcard from "./components/new-cards.vue";
import selectcard from "./components/cards-particulars.vue";
import redactcard from "./components/cards-redact.vue";

export default {
  name: "YXindex",
  data() {
    return {
      labelName: "cardhome",
      slideshow: null
    };
  },
  components: {
    cardhome,
    addcard,
    selectcard,
    redactcard
  },
  created() {},
  methods: {
    // 返回首页
    goBackHome() {
      this.labelName = "cardhome";
    },
    // 新增
    toAddRole() {
      this.labelName = "addcard";
    },
    // 详情
    tocheckRole(val) {
      this.labelName = "selectcard";
      console.log("获取", val);
      this.slideshow = val;
    },
    // 编辑
    toredactRole(val) {
      this.labelName = "redactcard";
      console.log("获取", val);
      this.slideshow = val;
    }
  }
};
</script>
